// Client für die SmartHaus-Geräte (Hue-Lampen, Shelly-Steckdosen).
// Karten-Positionen nutzen das Roborock-mm-Koordinatensystem (Origin 25600/25600),
// identisch zu Pin&Go — siehe /docs auf dem Backend.

import { req } from '@/services/vacuum'

export const devicesApi = {
  list: () => req('/devices'),
  setPosition: (id, x, y) =>
    req(`/devices/${encodeURIComponent(id)}/position`, {
      method: 'PUT',
      body: { x: Math.round(x), y: Math.round(y) },
    }),
  clearPosition: (id) =>
    req(`/devices/${encodeURIComponent(id)}/position`, { method: 'DELETE' }),
  setOn: (id, on) =>
    req(`/devices/${encodeURIComponent(id)}/on`, { method: 'POST', body: { on } }),
}

// Icon je Geräte-Kategorie (Backend-Feld `category`).
export function deviceIcon(device) {
  if (device.category === 'lamp') return device.on ? 'mdi-lightbulb-on' : 'mdi-lightbulb-outline'
  if (device.category === 'plug') return 'mdi-power-socket-de'
  if (device.category === 'vacuum') return 'mdi-robot-vacuum'
  return 'mdi-help-circle-outline'
}
